import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRuler } from "@fortawesome/pro-solid-svg-icons";

import Card from "@/components/card/index.tsx";
import Tooltip from "@/components/tooltip";
import scaleHighlight from "../../styles/scale-highlight.module.css";

interface ScaleCardActionProps {
    scaledStoreysCount: number;
    totalStoreysCount: number;
    isLoading?: boolean;
}

const ScaleCardAction: React.FC<ScaleCardActionProps> = ({
    scaledStoreysCount,
    totalStoreysCount,
}) => (
        <>
            <Tooltip
                id='scale-icon-tooltip'
                place='bottom-end'
                key='scale-icon-tooltip'
            >
                Réglez l'échelle de chaque étage
            </Tooltip>

            <Card additionalContentClasses='flex flex-col gap-y-2 px-4 py-2 text-sm'>
                <div className='flex flex-col gap-y-2'>
                    <span>Réglez l’échelle de chaque étage pour débloquer les calculs automatiques.</span>

                    <div className='flex flex-row items-center justify-between'>
                        <span>{scaledStoreysCount}/{totalStoreysCount} des étages ont été traités.</span>
                        <FontAwesomeIcon
                            icon={faRuler}
                            className={`${scaleHighlight.hint} rounded text-xl text-slate-900 cursor-help focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-500`}
                            aria-label="Réglez l'échelle de chaque étage"
                            data-tooltip-id='scale-icon-tooltip'
                        />
                    </div>
                </div>
            </Card>
        </>
    );

export default ScaleCardAction;
